const slugify = require('@sindresorhus/slugify')

exports.mySlugify = url => {
  return url.split('/').map(function (s) {
    // TODO
    if (s.includes('sprint_')) {
      return s
    } else {
      return slugify(s)
    }
  }).join('/')
}

exports.nomalizeUrl = url => {
  return url[url.length - 1] !== '/' ? url + '/' : url
}